import ProtocolForm from '../documents/ProtocolForm'

const DocumentHandoverCreate = () => {
  return <ProtocolForm type='handover-protocol'/>
}

export default DocumentHandoverCreate
